export default __webpack_public_path__ + "static/media/logo-abogados-vaf.4b12cfda.jpeg";